/**
 * Login utilities for Jeddle authentication
 * 
 * Supports two flows:
 * 1. Legacy: miniOrange OAuth Server (/moserver/authorize) - for backward compatibility
 * 2. New SSO: WordPress SSO plugin (/login) - for Google/Microsoft/School SSO
 */

const updateRedirectAt = () => {
   const url = new URL(window.location.href);
   const hashFragment = window.location.hash.substring(1);
   
   if (hashFragment) {
     url.hash = '';
     url.searchParams.set('redirect', hashFragment);
   }
   
   url.searchParams.set('redirect_at', Date.now());
   return url.toString();
 };

/**
 * Get the SSO login URL (new flow)
 * Redirects to WordPress /login page with SSO buttons
 */
export const ssoLoginUrl = () => {
  const jeddleBaseUrl = process.env.REACT_APP_JEDDLE_BASE_URL ?? 'https://jeddle.duxdigital.net';
  const appUrl = process.env.REACT_APP_SELF_BASE_URL ?? 'http://localhost:1234';
  
  // Build redirect URL with hash fragment preserved
  const redirectUrl = updateRedirectAt();
  
  // Use 'redirect_to' which is the standard WP login redirect parameter
  return `${jeddleBaseUrl}/login?redirect_to=${encodeURIComponent(redirectUrl)}&from_app=1`;
};

/**
 * Legacy OAuth flow URL
 * REMOVED: miniOrange OAuth Server support (deprecated)
 * Now redirects to new SSO flow for all users
 */
export const externalIDPUrl = () => {
  return ssoLoginUrl();
};

/**
 * Exchange SSO token for session (new flow)
 * Called when redirected back with ?sso_token= param
 */
export const exchangeSsoToken = async (ssoToken) => {
  const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080').replace(/\/$/, '');
  const url = `${apiBaseUrl}/auth/session`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ ssoToken }),
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error.error || 'Failed to exchange SSO token');
  }
  
  return response.json();
};
